import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Honest public counter for the SINGLE founding pool of 100. Reads ONE value — `total_seats`
// (founding.TOTAL_SEATS = 100) served flat by /founding/status — and breaks the gap out honestly
// as "N reserved · N claimed" (reserved + claimed + open === total). The gold number (#E8C46A)
// is the OPEN count that moves; an olive (#57682A) bar shows what's claimed. One shared sequence
// for individuals and businesses — there is no per-pool counter anymore.
export function FoundingCounter({ className = "" }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/founding/status").then(({ data }) => setP(data)).catch(() => {});
  }, []);
  if (!p) return null;
  const total = p.total_seats;                              // SINGLE SOURCE OF TRUTH (100)
  const open = p.public_remaining;                          // OPEN seats (counts down)
  const claimed = p.public_taken;                           // CLAIMED (public 11-100)
  const reserved = p.reserved ?? Math.max(0, total - p.public_seats);  // reserved block (10)
  const pct = total ? Math.min(100, Math.round((claimed / total) * 100)) : 0;
  return (
    <div data-testid="founding-counter" className={`inline-flex flex-col ${className}`}>
      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#8B8D90]">
        {total} Founding Seats
      </span>
      <span className="font-heading text-2xl font-black tracking-tight">
        <span data-testid="founding-remaining" className="text-[#E8C46A]">{open}</span>
        <span className="text-[#8B8D90]"> of {total} open</span>
      </span>
      <span className="mt-1 font-mono text-[10px] uppercase tracking-[0.12em] text-[#748A3D]" data-testid="founding-claimed">
        {reserved} reserved · {claimed} claimed
      </span>
      <div className="mt-1 h-1.5 w-full max-w-[220px]" style={{ backgroundColor: "#3E3F42" }}>
        <div className="h-full transition-all" style={{ width: `${claimed > 0 ? Math.max(pct, 4) : 0}%`, backgroundColor: "#57682A" }} data-testid="founding-bar" />
      </div>
    </div>
  );
}

export default FoundingCounter;
